import {API_BASEURL} from "../Constants";

export const logoUrl = (municipality_id, file) => {
    const url = API_BASEURL + `municipality/${municipality_id}/logo`;
    return file ? url + `?file=${file}` : url;
};
